<template>
    <div class="room__show">
        <div class="room__show_header">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="room__show_header_details">
                            <div class="columns">
                                <div class="column">
                                    <view-actions
                                        :breadcrumb-active="true"
                                        :breadcrumb-items="[
                                            {
                                                name: this.$t('ebs.rooms.show.title.venues'),
                                                to: { name: 'ebs-venue-list' }
                                            },
                                            {
                                                name: roomVenueName,
                                                to: roomVenueTo
                                            }
                                        ]"
                                        :cancel-button-active="false"
                                        :notify-title="$t('ebs.rooms.show.title.process')"
                                        :size="'small'"
                                        :status-active="true"
                                        :status-name="roomStatus"
                                        :submit-button-active="user.isInfrastructureManager()"
                                        :submit-button-text="roomAllowEdit ? this.$t('ebs.rooms.show.buttons.edit') : this.$t('ebs.rooms.show.buttons.view')"
                                        :title="roomName"
                                        :trash-button-active="user.isInfrastructureManager()"
                                        @emit-notify-remove-submit="roomRemove"
                                        @emit-submit="roomEdit"
                                        @emit-remove="roomRemove"
                                    />
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <div class="room__show_header_details_description">{{roomDescription}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="roomImages.length">
                        <div class="column is-narrow">
                            <div class="room__show_header_image">
                                <component-slider
                                    :images="roomImages"
                                    :alt="roomName"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="room__show_main">
            <div class="container">
                <div class="columns change--centered">
                    <div class="column is-4-desktop is-10-tablet is-12-mobile">
                        <component-location
                            :address="roomVenueAddress"
                        />
                        <template v-if="roomVenueContactPhone || roomVenueContactEmail">
                            <component-contact
                                :title="$t('ebs.rooms.show.contactRoom')"
                                :phone="roomVenueContactPhone"
                                :email="roomVenueContactEmail"
                            />
                        </template>
                        <template v-if="roomCapacity || roomCostPeriod">
                        <component-details
                            :capacity="roomCapacity"
                            :cost="roomCost"
                            :cost-period="roomCostPeriod"
                        />
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentSlider from '@/components/default/shared/ComponentSlider'
import ComponentLocation from '@/components/default/shared/ComponentLocation'
import ComponentContact from '@/components/default/shared/ComponentContact'
import ComponentDetails from '@/components/default/shared/ComponentDetails'
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'

export default {
  components: {
    ViewActions,
    ComponentDetails,
    ComponentContact,
    ComponentLocation,
    ComponentSlider
  },
  name: 'room-show',
  computed: {
    roomId: function () {
      return this.$store.getters['getRoomId']
    },
    roomName: function () {
      return this.$store.getters['getRoomName']
    },
    roomDescription: function () {
      return this.$store.getters['getRoomDescription']
    },
    roomStatus: function () {
      return this.$store.getters['getRoomStatus']
    },
    roomImages: function () {
      return this.$store.getters.getRoomImages.map(image => {
        return image.fileId
      })
    },
    roomCapacity: function () {
      return this.$store.getters['getRoomCapacity']
    },
    roomCost: function () {
      return this.$store.getters['getRoomCost']
    },
    roomCostPeriod: function () {
      return this.$store.getters['getRoomCostPeriod']
    },
    roomVenueId: function () {
      return this.$store.getters['getRoomVenueId']
    },
    roomVenueName: function () {
      return this.$store.getters['getRoomVenueName']
    },
    roomVenueTo: function () {
      return { name: 'ebs-venue-show', params: { id: this.roomVenueId } }
    },
    roomVenueContactEmail: function () {
      return this.$store.getters['getRoomVenueContactEmail']
    },
    roomVenueContactPhone: function () {
      return this.$store.getters['getRoomVenueContactPhone']
    },
    roomVenueAddress: function () {
      return this.$store.getters['getRoomVenueAddress']
    },
    roomAllowEdit () {
      return this.$store.getters.getRoomAllowEdit
    }
  },
  methods: {
    roomEdit: function () {
      this.$router.push({ name: 'ebs-room-edit', params: { id: this.roomId } })
    },
    roomRemove: function () {
      const roomId = this.$route.params.roomId
      this.$store.dispatch('removeRoom', roomId)
    }
  },
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/rooms/roomshow";
</style>
